import $ from "jquery";
import select2 from 'select2';

export default class InitSelect2 {

  static mount() {
    select2($);
  }
}